import {
  AlignLeft,
  Database,
  FileText,
  Files,
  Gauge,
  Image,
  LayoutGrid,
  Leaf,
  ListOrdered,
  Package,
  Percent,
  Ruler,
  Tag,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import type { OmdPanelTabId } from '../../utils/omdProductView';

export const OMD_TAB_ICONS: Record<OmdPanelTabId, LucideIcon> = {
  uebersicht: LayoutGrid,
  technik: Wrench,
  dokumente: Files,
  preise: Tag,
};

const SECTION_ICONS: Record<string, LucideIcon> = {
  Beschreibung: AlignLeft,
  Stammdaten: Database,
  Zubehör: Package,
  'Technische Merkmale': Gauge,
  'Maße & Gewicht': Ruler,
  'Umwelt & Konformität': Leaf,
  Ersatzteilliste: ListOrdered,
  Dokumente: Files,
  Bilder: Image,
  Materialzuschläge: Percent,
};

type OmdPanelIconProps = {
  icon: LucideIcon;
  className?: string;
  size?: 'sm' | 'md';
};

export function OmdPanelIcon({ icon: Icon, className = '', size = 'md' }: OmdPanelIconProps) {
  const sizeClass = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';
  return <Icon className={`${sizeClass} shrink-0 text-pipedrive-blue ${className}`.trim()} aria-hidden />;
}

export function getOmdTabIcon(tabId: OmdPanelTabId): LucideIcon {
  return OMD_TAB_ICONS[tabId];
}

export function getOmdSectionIcon(title: string, tabId?: OmdPanelTabId): LucideIcon {
  if (tabId) return OMD_TAB_ICONS[tabId];
  return SECTION_ICONS[title] ?? FileText;
}
